import eventRepo   from '../services/events';
import modulesRepo from '../services/modules';

export const TOGGLE_MOBILE_FILTERS        = 'TOGGLE_MOBILE_FILTERS';
export const PUBLIC_EVENTS_REFRESHED      = 'PUBLIC_EVENTS_REFRESHED';
export const MODULE_OPTIONS_REFRESHED     = 'MODULE_OPTIONS_REFRESHED';
export const EVENT_SEARCH_TEXT_CHANGED    = 'EVENT_SEARCH_TEXT_CHANGED';
export const EVENT_SORT_BY_CHANGED        = 'EVENT_SORT_BY_CHANGED';
export const EVENT_SUBJECT_FILTER_CHANGED = 'EVENT_SUBJECT_FILTER_CHANGED';
export const EVENT_TYPE_FILTER_CHANGED = 'EVENT_TYPE_FILTER_CHANGED';

export function eventTypeFilterChanged(eventType) {

    return {
        type: EVENT_TYPE_FILTER_CHANGED,
        eventType
    };
}

export function eventSubjectFilterChanged(moduleId) {

    return {
        type: EVENT_SUBJECT_FILTER_CHANGED,
        moduleId
    };
}

export function sortByChanged(sortBy) {

    return {
        type: EVENT_SORT_BY_CHANGED,
        sortBy
    };
}

export function searchTextChanged(searchText) {

    return {
        type: EVENT_SEARCH_TEXT_CHANGED,
        searchText
    };
}

function getPublicEventParams(eventListState) {

    const params = {
        sort: eventListState.sortBy
    };

    if (eventListState.searchText !== '') {

        params['search'] = eventListState.searchText;
    }

    if (eventListState.filterByModuleId !== '0') {

        params['module_id'] = eventListState.filterByModuleId;
    }

    if (eventListState.filterByEventType !== '0') {

        params['event_type'] = eventListState.filterByEventType;
    }

    return params;
}

export function searchEvents(searchText) {

    return (dispatch, getState) => {

        function getSuccess(response) {

            dispatch(eventsRefreshed(response.data.data));
        }

        dispatch(searchTextChanged(searchText));

        const params = getPublicEventParams(getState().eventList);

        eventRepo.getPublicEvents(params)
            .then(getSuccess);
    };
}

export function sortEventsBy(sortBy) {

    return (dispatch, getState) => {

        function getSuccess(response) {

            dispatch(eventsRefreshed(response.data.data));
        }

        dispatch(sortByChanged(sortBy));

        const params = getPublicEventParams(getState().eventList);

        eventRepo.getPublicEvents(params)
            .then(getSuccess);
    };
}

export function filterEventsByModuleId(moduleId) {

    return (dispatch, getState) => {

        function getSuccess(response) {

            dispatch(eventsRefreshed(response.data.data));
        }

        dispatch(eventSubjectFilterChanged(moduleId));

        const params = getPublicEventParams(getState().eventList);

        eventRepo.getPublicEvents(params)
            .then(getSuccess);
    };
}

export function filterEventsByEventType(eventType) {

    return (dispatch, getState) => {

        function getSuccess(response) {

            dispatch(eventsRefreshed(response.data.data));
        }

        dispatch(eventTypeFilterChanged(eventType));

        const params = getPublicEventParams(getState().eventList);

        eventRepo.getPublicEvents(params)
            .then(getSuccess);
    };
}

export function refreshModules() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(modulesRefreshed(response.data.data));
        }

        modulesRepo.getAll()
            .then(getSuccess);
    }
}

export function modulesRefreshed(modules) {

    return {
        type: MODULE_OPTIONS_REFRESHED,
        modules
    }
}

export function refreshEvents() {
    
    return (dispatch, getState) => {

        function getSuccess(response) {

            dispatch(eventsRefreshed(response.data.data));
        }

        const params = getPublicEventParams(getState().eventList);

        eventRepo.getPublicEvents(params)
            .then(getSuccess);
    };
}

export function eventsRefreshed(events) {

    return {
        type: PUBLIC_EVENTS_REFRESHED,
        events
    };
}

export function toggleMobileFilterVisibility() {

    return {
        type: TOGGLE_MOBILE_FILTERS
    }
}


// WEBPACK FOOTER //
// ./actions/publicEventList.js